import { httpsCallable } from 'firebase/functions';
import { functionsEu } from '../firebase';

const normalize = (value: string) => value.trim().toLowerCase();

export function getSharedInterests(left: string[] = [], right: string[] = []) {
  const rightSet = new Set(right.map(normalize));
  return left.filter(item => rightSet.has(normalize(item)));
}

// Unvibe is mutual and destructive (removes the relationship for both
// users, deletes the shared chat and every message in it), so it has to be
// backend-authoritative: the client only ever names *who* it wants to
// unvibe, never a chatId — the Cloud Function derives the pair's actual
// relationship/chat from trusted server-side data, and does the recursive
// message deletion a client can never be granted permission to do directly
// (see firestore.rules, privateChats/{chatId}/messages: `allow update,
// delete: if false`). See functions/index.js's unvibeUserHandler.
// Deliberately NOT gated on email-verification restriction: unvibing
// disconnects an existing relationship (a safety-relevant action, like
// declining a request or blocking someone) rather than extending social
// reach, and a legacy relationship can exist even for an account that
// predates this feature — never trap a restricted account in an unwanted
// connection it can't leave.
export async function unvibeUsers(otherUserId: string): Promise<void> {
  const unvibeFn = httpsCallable<{ otherUserId: string }, { success: boolean }>(functionsEu, 'unvibeUserEu');
  const response = await unvibeFn({ otherUserId });
  if (!response.data?.success) {
    throw new Error('Unvibe failed.');
  }
}
